// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

import '@/utils/rem'

// 引入全局自定义指令
import intAll from '@/utils/int'
import intBurden from '@/utils/intBurden'
import permission from '@/directives/vPermission'
const directives = {
  // 指令对象
  permission,
  intAll,
  intBurden,
}

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  // 注册全局自定义指令
  Object.keys(directives).forEach((key) => {
    app.directive(key, directives[key])
  })

  app.mount('#app')
}

setupAll()
